import './index.scss';
import React, { useMemo } from 'react';
import { Button as MaterialButton } from '@material-ui/core';
import cx from 'classnames';

export type IButtonType = 'basic' | 'stroke' | 'tertiary' | 'tertiary-black' | 'basic-secondary';

interface IButtonProps {
  children: React.ReactNode;
  type?: IButtonType;
  disabled?: boolean;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  testId?: string;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

interface IButtonThemeProps {
  variant: 'contained' | 'outlined' | 'text';
  color: 'primary' | 'secondary';
}

export const Button = ({
  type = 'basic',
  children,
  disabled = false,
  startIcon,
  endIcon,
  onClick,
  testId = 'ds-button-container',
}: IButtonProps) => {
  const buttonThemeProps = useMemo<IButtonThemeProps>(() => {
    if (type === 'basic') {
      return {
        variant: 'contained',
        color: 'primary',
      };
    }

    if (type === 'stroke') {
      return {
        variant: 'outlined',
        color: 'primary',
      };
    }

    if (type === 'tertiary-black') {
      return {
        variant: 'text',
        color: 'primary',
      };
    }

    if (type === 'basic-secondary') {
      return {
        variant: 'contained',
        color: 'secondary',
      };
    }

    return {
      variant: 'text',
      color: 'secondary',
    };
  }, [type]);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (!disabled) {
      onClick(e);
    }
  };

  return (
    <div
      data-testid={testId}
      className={cx('ds-button', {
        [type]: true,
        disabled,
      })}
    >
      <MaterialButton
        variant={buttonThemeProps.variant}
        color={buttonThemeProps.color}
        disableTouchRipple
        disableElevation
        startIcon={startIcon}
        endIcon={endIcon}
        onClick={handleClick}
      >
        {children}
      </MaterialButton>
    </div>
  );
};
